/**
 * web/src/styles/cssIds.ts —— 样式注入元素 id **单源**（FE-N-2；AUD3B/L-IA-FEN234）。
 * 原 21+ 文件各持一份 `const CSS_ID = "…"` 局部声明（grep -rl CSS_ID web/src ⇒ 22 文件）⇒ 本件收一。
 * 消费方：各渲染件 `import { cssIds } from "…/styles/cssIds"`；键＝件名 camelCase。
 */
export const cssIds = {
  approvalBlock: "xg-node-css-approval",
  artifactBlock: "xg-node-css-artifact",
  assistantBlock: "xg-node-css-assistant",
  commandRow: "xg-node-css-command",
  deliverableGrid: "xg-css-deliverable-grid",
  errorRow: "xg-node-css-error-row",
  markdown: "xg-markdown-css",
  messageUserBlock: "xg-node-css-message-user",
  nodeDeliveryRow: "xg-node-css-node-delivery",
  questionBlock: "xg-node-css-question",
  questionCard: "xg-css-question-card",
  thinkingCard: "xg-css-thinking-card",
  todoBlock: "xg-node-css-todo",
  todoCard: "xg-css-todo-card",
  toolCallBlock: "xg-node-css-tool-call",
  toolRow: "xg-css-tool-row",
  turnProcessRow: "xg-node-css-turn-process",
  turnTailRow: "xg-node-css-turn-tail",
  uiIcon: "xg-css-ui-icon",
  unknownRow: "xg-node-css-unknown-row",
  waitsView: "xg-view-css-waits",
  xgIcon: "xg-css-xg-icon",
} as const;
